export const AdjustmentsActionTypes = {
    API_RESPONSE_SUCCESS: '@@adjustments/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@adjustments/API_RESPONSE_ERROR',
    GET_ALL_ADJUSTMENTS: '@@adjustments/GET_ALL_ADJUSTMENTS',
    RESET_STATE: '@@adjustments/RESET_STATE',
    RESET_ALL_ERRORS: '@@adjustments/RESET_ALL_ERRORS',
};
